export default {
  resource: 'comparison-operators',
  actions: ['index']
}
